import "./svg/bb_sesong.svg"

export default {
    name: "bb_sesong",
    viewBox: "40 40",
}
